import { COLORS } from "@bikdotai/bik-component-library";
import styled from "styled-components";

export const BuilderContainer = styled.div`
  overflow-y: auto;

  /* Force the QB date-picker calendar to open upward.
     The popup wrapper (position:absolute, z-index:3) is the direct parent of
     .react-calendar — target it via :has() so bottom:100% works. */
  div:has(> .react-calendar) {
    bottom: 100% !important;
    top: auto !important;
    transform: translateY(120px);
  }
`;

export const InstaDropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 12px;
  .dropdown-text {
    margin-left: 12px;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const InstaDropdownContainer = styled.div`
  border-radius: 4px;
  border: 1px solid ${COLORS.stroke.primary};
  cursor: pointer;
  background-color: #fff;
  &:hover {
    background-color: ${COLORS.surface.hovered};
  }
`;

export const TriggerOnRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`;

export const ExcludeToggleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin: 24px -24px;
  padding: 16px 24px 0;
  border-top: 1px solid ${COLORS.stroke.primary};
`;
